import { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from '../ui/button';
import { PathkitLogo, PK_COLORS } from '../PathkitLogo';

const navLinks = [
  { href: '#features', label: 'Features' },
  { href: '#platforms', label: 'Platforms' },
  { href: '#pricing', label: 'Pricing' },
  { href: '#faq', label: 'FAQ' },
];

export function MarketingNav() {
  const [open, setOpen] = useState(false);

  return (
    <header
      className="sticky top-0 z-40 border-b border-slate-200 bg-white/85 backdrop-blur"
      aria-label="Site navigation"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          <a href="/" className="flex items-center gap-2 group">
            <PathkitLogo className="w-8 h-8" />
            <span className="text-lg font-semibold tracking-tight" style={{ color: PK_COLORS.navy }}>
              PathKit
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-8" aria-label="Primary">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="text-sm text-slate-600 hover:text-slate-900 transition-colors"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-2">
            <Button variant="ghost" size="sm" asChild>
              <a href="/login">Sign in</a>
            </Button>
            <Button
              size="sm"
              asChild
              style={{ backgroundColor: PK_COLORS.navy, color: '#ffffff' }}
              className="hover:opacity-90"
            >
              <a href="/book-demo" style={{ color: '#ffffff' }}>Book a demo</a>
            </Button>
          </div>

          <button
            type="button"
            className="md:hidden inline-flex items-center justify-center w-10 h-10 rounded-md text-slate-600 hover:bg-slate-100"
            aria-label={open ? 'Close menu' : 'Open menu'}
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>

        {open && (
          <div className="md:hidden border-t border-slate-200 py-3 space-y-1">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="block px-2 py-2 rounded text-sm text-slate-700 hover:bg-slate-100"
                onClick={() => setOpen(false)}
              >
                {l.label}
              </a>
            ))}
            <div className="pt-2 flex flex-col gap-2">
              <Button variant="outline" size="sm" asChild>
                <a href="/login">Sign in</a>
              </Button>
              <Button
                size="sm"
                asChild
                style={{ backgroundColor: PK_COLORS.navy, color: '#ffffff' }}
                className="hover:opacity-90"
              >
                <a href="/book-demo" style={{ color: '#ffffff' }}>Book a demo</a>
              </Button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
